module.exports = __webpack_public_path__ + "static/poster-2-03a3909c7ab6bfbf0254110a8b9a3e37.jpg";